import React, { useState } from "react";
import { FaArrowLeft, FaPhone } from "react-icons/fa";
import { IoMailOutline } from "react-icons/io5";
import {
  AssignmentTab,
  ClassesTab,
  ExamsTab,
  FeesTab,
  GeneralTab,
  QuizTab,
} from "../../../components/parentDashboard/studentProfileTabs";
import { Link } from "react-router-dom";

const tabs = [
  {
    heading: "General",
    component: <GeneralTab />,
  },
  {
    heading: "Quiz",
    component: <QuizTab />,
  },
  {
    heading: "Exams",
    component: <ExamsTab />,
  },
  {
    heading: "Assignment",
    component: <AssignmentTab />,
  },
  {
    heading: "Classes",
    component: <ClassesTab />,
  },
  {
    heading: "Fees",
    component: <FeesTab />,
  },
];

const StudentProfile = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <section>
      <div className="px-10 pt-20">
        <Link to={-1} className="flex gap-[27px] items-center">
          <span>
            <FaArrowLeft size={30} />
          </span>
          <div className="justify-start text-[#3c3c3c] text-[32px] font-semibold font-['Inter']">
            Student Profile
          </div>
        </Link>

        <div className="mt-20 flex w-[80%] max-w-[1000px] items-center justify-between">
          <div className="flex gap-[36px]">
            <span>
              <img src="/blackman.png" alt="blackman" className="w-[102px]" />
            </span>
            <div className="flex flex-col">
              <p className="justify-start text-[#3c3c3c] text-2xl font-semibold font-['Inter']">
                Tolulope Ayodeji
              </p>
              <p className="justify-start text-[#3c3c3c] text-base font-semibold font-['Inter']">
                Student ID : TIPSG5682
              </p>
              <p className="justify-start text-[#3c3c3c] text-base font-semibold font-['Inter']">
                Gender : Female
              </p>
            </div>
          </div>
          <div className="w-[367px] h-[143px] bg-[#f2edfd] flex flex-col justify-between rounded-[5px] py-4 px-10">
            <p className="justify-start text-[#3c3c3c] text-2xl font-semibold font-['Inter']">
              Attendance
            </p>
            <div className="flex w-full items-end justify-between">
              <p className="justify-start text-[#8147e7] text-5xl font-semibold font-['Inter']">
                85%
              </p>
              <p className="justify-start">
                <span class="text-[#3edb4e] text-2xl font-semibold font-['Inter']">
                  85
                </span>
                <span class="text-[#3c3c3c] text-2xl font-semibold font-['Inter']">
                  /100
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div className="w-full border-b flex px-10 mt-[50px] gap-[50px]">
          {tabs.map((item, index) => (
            <button
              onClick={() => setActiveIndex(index)}
              key={index}
              className={` pb-5 text-xl font-normal font-['Inter'] ${
                tabs[activeIndex].heading === item.heading
                  ? "text-[#3D70F5] border-b border-[#3D70F5]"
                  : "text-[#707070]"
              }`}
            >
              {item.heading}
            </button>
          ))}
        </div>
      </div>
      {tabs[activeIndex].component}
    </section>
  );
};

export default StudentProfile;
